module.exports = {
  width: 230,
  height: 150,
  bytes: 3260,
  type: "svg",
};
module.exports.toString = function() {
  return __webpack_public_path__ + undefined;
};